import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayContains',
    standalone: true
})
export class ArrayContainsPipe<T> implements PipeTransform {
    transform(value: T, array: T[]): boolean {
        return array ? array.includes(value) : false;
    }
}
